import React, { useEffect, useState } from "react";
import { Box, VStack, Input, Text, Field, Link } from "@chakra-ui/react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { loginRequest } from "../../store/features/user/userActions";
import AppCard from "../reusables/AppCard/AppCard";
import CustomButton from "layouts/CustomButton/CustomButton";

const Login: React.FC = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const { isAuthenticated, loading, subscription } = useSelector(
    (state: RootState) => state.user,
  );

  const from = (location.state as any)?.from || "/";

  const handleCredentialsSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    if (!email) {
      setError("Email is required");
      return;
    }
    if (!password) {
      setError("Password is required");
      return;
    }
    dispatch(loginRequest({ email, password }));
  };

  useEffect(() => {
    if (isAuthenticated) {
      navigate(from, { replace: true });
    }
  }, [isAuthenticated, navigate, from]);

  return (
    <>
      <AppCard
        header={"Login"}
        headerClass="text-2xl font-bold text-gray-700 align-left"
      >
        <Box>
          <VStack gap={6}>
            {error && (
              <Box
                p={4}
                bg="fail.50"
                color="fail.700"
                borderRadius="lg"
                w="full"
                border="1px solid"
                borderColor="fail.200"
              >
                {error}
              </Box>
            )}

            <Box as="form" onSubmit={handleCredentialsSubmit} w="full">
              <VStack gap={5}>
                <Field.Root required>
                  <Field.Label fontWeight="semibold" color="gray.700">
                    Email Address
                  </Field.Label>
                  <Input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter your email"
                    size="lg"
                    borderRadius="lg"
                    borderColor="gray.300"
                    _focus={{
                      borderColor: "brand.500",
                      boxShadow: "0 0 0 1px var(--chakra-colors-brand-500)",
                    }}
                  />
                </Field.Root>

                <Field.Root required>
                  <Field.Label fontWeight="semibold" color="gray.700">
                    Password
                  </Field.Label>
                  <Input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Enter your password"
                    size="lg"
                    borderRadius="lg"
                    borderColor="gray.300"
                    _focus={{
                      borderColor: "brand.500",
                      boxShadow: "0 0 0 1px var(--chakra-colors-brand-500)",
                    }}
                    autoComplete="off"
                  />
                </Field.Root>

                <CustomButton
                  // _hover={{ bg: "brand.600" }}
                  type="submit"
                  bg="brand.500"
                  color="white"
                  size="lg"
                  loading={loading}
                >
                  Sign In
                </CustomButton>
                <Box color="fail.700">{subscription.error}</Box>
              </VStack>
            </Box>
          </VStack>

          <Box borderColor="gray.200" className="display-flex text-center my-4">
            <Link href="/" display="flex" alignItems="center" gap={2}>
              <Text
                fontSize="sm"
                fontWeight="medium"
                color={"brand.600"}
                textDecoration="underline"
              >
                back to home
              </Text>
            </Link>
          </Box>
        </Box>
      </AppCard>
    </>
  );
};

export default Login;
